import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/jquery.lazyload-custom.js";
import "LIBS/jquery.history.js";

import "HSNDIR/Topology.js";
import "HSNDIR/Template.js";
import "HSNDIR/Flyout.js";
import "HSNDIR/Widget/ProductCards.js";
import "HSNDIR/Template/ProductVideo.js";
import "HSNDIR/Template/CommPrefBrands.js";
import "HSNDIR/TabPanel.js";

// Used in content
import "HSNDIR/Widget/Favorite.js";
import "HSNDIR/Breadbox.js";
import "HSNDIR/Breadbox2.js";
import "LIBS/jquery.jtruncate.js";

//used in childaction
import "HSNDIR/Widget/BloomReach.js";
import "HSNDIR/Widget/SwatchBox";

/**
    * class HSN.Template.ProductGrid
    *
    * Encapsulates the functionality the Product Grid page.
    **/
HSN.Template.ProductGrid = function (config) {
    /**
    * new HSN.Template.ProductGrid(config)
    * - config (Object): A configuration object for the [[HSN.Template.ProductGrid]]
    *   consisting of the following keys:
    *   - application (HSN.Application): The [[HSN.Application]] instance this template exists within and should interact with.
    *   - container (HTMLElement): The HTML element that acts as the root container for the template.
    **/
    var __scope = this;
    this._ajaxCount = 0;

    this.Application = config.application;
    this.Container = $(config.container);
    this.Breadcrumbs = $("#breadcrumb");
    this.SwatchBox = new HSN.Widget.SwatchBox();

    this.PageSize = parseInt($("#page-size").val()) || 200;
    this._isScrollAll = (HSN.Instance().GetQueryStringParam(window.location.search, "scroll") == "all") ? true : false;
    this._isBonusBuy = false;
    this._isLessman = $('#template-product-grid.lessman').length;
    this._isLessmanSearch = $('#search-index-lessman').length;

    // decide the correct url to query for more products
    var pathname = window.location.pathname.toLowerCase();

    if(pathname.startsWith('/shop')){
        this._baseUrl = '/shop';
        if (this._isLessman) {
            this._ajaxUrl = '/show-more-products-lessman';
        }
        else {
            this._ajaxUrl = '/show-more-products';
        }
        this._withSlug = true;
    } else if (pathname.startsWith('/search')) {
        this._baseUrl = '/search';
        if (this._isLessman) {
            this._ajaxUrl = '/search-more-products-lessman';
        }
        else {
            this._ajaxUrl = '/search-more-products';
        }
        this._withSlug = false;
        this._searchQuery = HSN.Instance().GetQueryStringParam(window.location.search, 'query');
    } else if(pathname.startsWith('/bonusbuy/grid')) {
        this._baseUrl = '/bonusbuy/grid';
        this._ajaxUrl = '/bonusbuy/grid';
        this._isBonusBuy = true;
        this._withSlug = false;
        this._noTopology = true;
    }
        
    var productCards = new HSN.Widget.ProductCards(config); // used only for the side effect of initializing the cards' JS

    this.adjustProductGrid = function () {
        var bottomPager = $(".bottom-pager");
        var topPager = $(".top-pager");
        if(topPager.length === 0) return;

        var moduleWidth = 242;
        var moduleRightMax = topPager.position().left + topPager.outerWidth();
        var columns = 3;
        var cycleLimit = 100;

        var cycles = 0;
        var productGroups = $(".product-group");
        productGroups.each(function (index) {
            if (index > 0 && $(".list-product-item")) {
                var productGroup = $(this);
                var lastItemPosition = productGroup.prev(".item").position().left + moduleWidth;
                while (lastItemPosition < moduleRightMax && (cycles++ < cycleLimit)) {
                    productGroup.prev(".item").after("<div class='item module'>&nbsp;</div>");
                    lastItemPosition = productGroup.prev(".item").position().left + moduleWidth;
                }
            }
        });

        cycles = 0;
        var itemsAbovePager = $("#template-product-grid").find(".item");
        if (itemsAbovePager.length) {
            var lastItem = itemsAbovePager.last();
            __scope.UpdatePagingControlVisibility();

            var lastItemRight = lastItem.position().left + lastItem.outerWidth();
            var lastItemBottom = lastItem.position().top + lastItem.outerHeight();
            var breadbox = this.Container.find("#breadbox");
            var breadboxBottom = breadbox.length > 0 ? breadbox.position().top + breadbox.outerHeight() : 0;

            if ($(".list-product-item")) {
                while ((lastItemRight < moduleRightMax || lastItemBottom < breadboxBottom) && (cycles++ < cycleLimit)) {
                    if ($("#next-take").val() === "0" || $(".item").length < columns || $(".item").length + $(".in-grid").length < columns) {
                        lastItem.after("<div class='item module'></div>");
                    }
                    else {
                        bottomPager.prev(".product-group").remove();
                    }

                    lastItem = $("#template-product-grid").find(".item").last();
                    lastItemRight = lastItem.position().left + lastItem.outerWidth();
                    lastItemBottom = lastItem.position().top + lastItem.outerHeight();
                }
            }
        }
        this.adjustCMSContent();
    };
    this.adjustCMSContent = function () {
        const $prodCards = this.Container.find('.item:not(.product-item)');

        $prodCards.each((i, v) => {
        const $cur = $(v);
        $cur.addClass($cur.width() > 300 ? 'width-double' : 'width-single');
    });
    }
    if (!Modernizr.touchevents) {
        HSN.Tooltip(this.Container.find("[data-tooltip]"));
    }

    this.InitGrid();
    this.CheckPrivateSale();

    // setup event handlers on the Container node which will not be removed from the page.
    // filtering
    this.Container
        // filtering
        .on("click", ".filters a.clear-all, .filter-selections .clear-all a, .lnav .lnav-selected-filters .clear-all", function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($(".lnav").length > 0) {
                cmCreateManualLinkClickTag("/LNav?cm_re=FilterBy-_-Clear-filter-_-ALL&cm_sp=FilterBy-_-Clear-filter-_-ALL");
            }

            __scope.ClearAllFilters();
        })
        .on("click", "input[id^=\"spotlight-filter-\"]:checkbox, input[id^=\"filter-\"]:checkbox", function (e) {
            var checked = e.target.checked;
            var facetName = $(this).data("cmname");
            var prefix = $(this).is(":checked") ? "Breadbox" : "RemoveFilter";
            if ($(this).closest(".lnav-spotlight-filters-module").length > 0) {
                cmCreateManualLinkClickTag("/LNav?cm_re=" + prefix + "-_-PopularFilters-_-" + facetName);
            }
            else {
                var cmname = $(this).closest("dd").data("cmname");
                cmCreateManualLinkClickTag("/LNav?cm_re=" + prefix + "-_-" + cmname + "-_-" + facetName);
            }

            var ariaTag = $(this).closest('a');
            ariaTag.attr('aria-checked', checked);
            var id = $(this).data("id");
            if (checked) {
                __scope.AddFilter(id);
            }
            else {
                __scope.RemoveFilter(id);
            }
        })
        .on("click", ".filter-selections dd ul li a, .lnav .lnav-selected-filters li", function (e) {
            var name = $(this).data("name");
            var id = $(this).data("id");

            if ($(".lnav").length > 0) {
                cmCreateManualLinkClickTag("/LNav?cm_re=FilterBy-_-Clear-filter-_-" + name);
            }
            else {
                doCMClearSelection(name);
            }

            __scope.RemoveFilter(id);
            __scope.SendEdgecaseFilterEvent(this);

            return false;
        })

        // Lessman
        .on('click', '#selected-filters .clear-all', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (window.cmCreateManualLinkClickTag) {
                cmCreateManualLinkClickTag('/LNav?cm_re=FilterBy-_-Clear-filter-_-ALL');
            }

            __scope.ClearAllFilters();
        })
        .on('click', '#selected-filters ul li a', function (e) {
            e.preventDefault();

            var name = $(this).data('name');
            var id = $(this).data('id');

            if (window.cmCreateManualLinkClickTag) {
                cmCreateManualLinkClickTag('/LNav?cm_re=FilterBy-_-Clear-filter-_-' + name);
            }

            __scope.RemoveFilter(id);
            __scope.SendEdgecaseFilterEvent(this);

            return false;
        });

    // sorting
    this.Container
        .on('click', 'div.sort ul li a', function (e) {
            e.preventDefault();
            var cur = $(this);
            var text = cur.text();
            
            if (__scope._isLessman) {
                var sortId = cur.data('id');

                $('div.sort label span.selected').text(text);
                $('div.sort').data('id', sortId);
            }
            else {
                $('div.sort label span').text(text);
            }

            $('div.sort label').click();
            
            __scope.AddHistoryItem();
        })
        .on("blur", ".lnav-controls .sort", function () {
            $(this).attr('aria-expanded', 'false');
        })
        .on("keydown", ".lnav-controls .sort", function (e) {
            var key = e.keyCode;
            var expanded = this.hasAttribute('aria-expanded');
            var invalidKeys = [37, 38, 39, 40];
            invalidKeys.forEach(x => {
                if (x === key && !expanded) {
                    e.preventDefault();
                }
            });
            if (key === 32) {
                $(this).attr('aria-expanded', 'true');
            }
        })
        .on("change", ".lnav-controls .sort", function (e) {
            e.preventDefault();
            var isBloomreach = $("#template-product-grid.bloomreach").length;
            if (isBloomreach) {
                window.location.href = window.location.pathname + "?sort=" + $(this).val();
            }
            else {
                $('h1').focus();
                __scope.AddHistoryItem();
            }
        });


    // paging
    this.Container
        .on("keypress", "#paging-page-1, #paging-page-2", function(e) {
            if(e.which === 13 /* enter */) {
                e.preventDefault();

                var currentPageSize = $("#take").val();
                var page = parseInt($(this).val());
                var skip = (currentPageSize * page) - currentPageSize;

                $("#skip").val(skip);

                __scope.AddHistoryItem();
            }
        })
        .on("click", ".prev a", function(e) {
            e.preventDefault();

            HSN.Template.CommPrefBrands.prototype.BrandPagePrevious();
        })
        .on("click", ".next a", function(e) {
            e.preventDefault();

            HSN.Template.CommPrefBrands.prototype.BrandPageNext();
        })
        .on("click", ".pager-link", function(e) {
            if ($(this).hasClass("disabled")) {
                return false;
            }

            //value to pass into coremetrics
            var pageValue = $(this).text();

            if($(this).hasClass("prev-link")) {
                pageValue = "Beginning";
            }
            else if($(this).hasClass("next-link")) {
                pageValue = "End";
            }
               
            cmCreateManualLinkClickTag("/Grid?cm_re=Grid-_-Pagination-_-" + pageValue + "&cm_sp=Grid-_-Pagination-_-" + pageValue);

            $("#skip").val($(this).data("skip"));
            $("#page").val($(this).data("page"));
            $("#take").val($(this).data("take"));
            __scope.AddHistoryItem();

            return false;
        })        
        .on("click", ".prev-next a, .page-prev-next, #bottom-pager.v2 .previous-link, #bottom-pager.v2 .next-link", function (e) {
            e.preventDefault();

            if($(this).hasClass("disabled")) {
                return;
            }

            var type = $(this).attr("rel");
            var skip = parseInt($("#" + type + "-skip").val());
            var page = parseInt($("#" + type + "-page").val());
            var take = parseInt($("#" + type + "-take").val());

            var coremetricsPagingArea = ($(this).parents().hasClass("paged")) ? "TopPagination" : "Pagination";
               
            var pageValue = (type === "next") ? "Next" : "Previous";
            cmCreateManualLinkClickTag("/Grid?cm_re=Grid-_-" + coremetricsPagingArea + "-_-" + pageValue + "&cm_sp=Grid-_-" + coremetricsPagingArea + "-_-" + pageValue);

            $("#skip").val(skip);
            $("#page").val(page);
            $("#take").val(take);

            __scope.AddHistoryItem();
        });


    // Update the Scroll To Top callout's position as we scroll the page.
    this.ScrollToTopCallout = new ScrollToTopCallout(this.Container, ".scroll-to-top");

    // Throttle scroll actions
    var minScrollTime = 30;
    var scrollTimer, lastUpdateTime = 0;
    var $window = $(window);
    var $document = $(document);

    $(document).on("scroll", function(e) {
        if(!scrollTimer) {
            scrollTimer = setTimeout(function() {
                scrollTimer = null;
                lastUpdateTime = new Date().getTime();

                __scope.ScrollToTopCallout.UpdatePosition();

                // Load products as we approach the bottom of the grid
                if(__scope._isScrollAll){
                    var windowTop = $window.scrollTop();
                    var windowHeight = $window.height();
                    var documentHeight = $document.height();
                    var scrollTrigger = 3000;

                    if ((windowTop + windowHeight) > (documentHeight - scrollTrigger)) {
                        __scope.LoadProducts();
                    }
                }
            }, minScrollTime);
        }
    });

    // Capture url changes and reload grid data.
    History.Adapter.bind(window, "statechange", function (e) {
        var state = History.getState();
        var data = state.data;

        __scope.RefreshGrid(data);
    });
   
    HSN.Instance().Events.Trigger(HSN.Template.ProductGrid.EVENT.LOADED);
};

HSN.Template.ProductGrid.prototype = {
    _ajaxTimer: null,
    _isScrollAll: false,
    _isLoading: false,
    _areNoMoreResults: false,
    _UiState: { PAGED: 0, SCROLL: 1 },
    PageSize: 0,

    /**
    * HSN.Template.ProductGrid#Application -> HSN.Application
    *
    * Provides access to the [[HSN.Application]] instances it interacts with.
    **/
    Application: null,

    /**
    * HSN.Template.ProductGrid#Container -> jQuery
    *
    * Provides access to the jQuery-wrapped HTMLElement that acts as the root element of the template.
    **/
    Container: null,

    /**
    * HSN.Template.ProductGrid#OnUIUpdate() -> void
    *
    * Updates the UI based on state: enables/disables paged and scrollAll UI
    **/
    OnUIUpdate: function (state) {
        switch (state) {
            case this._UiState.PAGED:
                $('.scrollAll').addClass('hide');
                $('.paged').removeClass('hide');
                $('.bottom-pagination').show();
                $('.scroll-all a').removeClass('disabled');
                $('.scroll-all a').attr('tabIndex', '0');
                $('.top-pagination-count').addClass('active');
                break;

            case this._UiState.SCROLL:
                $('.scrollAll').removeClass('hide');
                $('.paged').addClass('hide');
                $('.bottom-pagination').hide();
                $('.scroll-all a').addClass('disabled');
                $('.scroll-all a').removeAttr('tabIndex');
                $('.top-pagination-count').removeClass('active');
                break;
        }

        $('.paging-nav').removeClass('hide');
    },

    OnFilterChange: function (me) {
        $("#skip").val(0);
        $("#take").val(this.PageSize);
        $("#page").val(1);
            
        this.RefreshFilterDisplay();
        this.AddHistoryItem();
    },

    RefreshGrid: function (data) {
        if (!this._ignoreStateChange) {
            this._isScrollAll = data.scroll;
            data.topology = data.topology ? HSN.Topology.FromObject(data.topology) : HSN.Topology.FromLocation(window.location);
            data.query = HSN.Instance().GetQueryStringParam(window.location.search, "query");
            this.StartAjaxGetTimer(data);
                
            // Jump to the top of the page.
            document.body.scrollTop = document.documentElement.scrollTop = 0;
                                
            $('select.sort').val(data.sort);
        }
    },

    ReplaceHistoryItem: function () {
        var data = this.GetData();

        this._ignoreStateChange = true;

        History.replaceState(data, window.document.title, this.GetUrl(data));

        this._ignoreStateChange = false;
    },

    AddHistoryItem: function (forcedData) {
        var data = forcedData || this.GetData();

        // nothing to see here... you're trying to get a grid of everything
        if(!this._noTopology && 
            !data.query &&
            !data.topology.deptId && 
            (!data.topology.facets || data.topology.facets.length === 0)){
            window.location = "/";
            return;
        }

        History.pushState(data, window.document.title, this.GetUrl(data));
    },
        
    /**
    * HSN.Template.ProductGrid#StartAjaxGetTimer() -> void
    *
    * Sets the timer to make the AJAX call. Resets the timer if another call is made within 1 second so as not to have multiple calls.
    **/
    StartAjaxGetTimer: function (data) {
        var self = this;

        if (this._ajaxTimer != null) {
            clearTimeout(this._ajaxTimer);
        }

        this._ajaxTimer = setTimeout(function () {
            self._areNoMoreResults = false;

            self.AjaxGet(data, self._isScrollAll);
        }, 1000);
    },

    /**
    * HSN.Template.ProductGrid#AjaxGet() -> void
    *
    * Gets the products satisfying the selected filters.
    **/
    AjaxGet: function (data, scrollAll) {
        var self = this;
        this._isLoading = true;
        this._ajaxCount += 1;
        var currentAjaxCount = this._ajaxCount;

        $.ajax(self.GetAjaxUrl(data), {
            dataType: "json",
            success: function(responseData){
                if(self._ajaxCount !== currentAjaxCount) return;

                if(self._isBonusBuy) {
                    var fullPage = $.parseHTML(responseData.View, document, true);

                    // Replace Page
                    self.Container.empty().append(fullPage);
                }
                else {
                    var $dom = $($.parseHTML(responseData.View, document, true));

                    if (self._isLessman && self._isLessmanSearch) {
                        var torso = $dom.filter('#torso.lessman-torso');

                        // Replace Grid
                        self.Container.empty().html(torso.find('#template-product-grid').html());

                        // Replace Breadcrumbs
                        $('#breadcrumbs').empty().html(torso.find('#breadcrumbs').html());
                    }
                    else {
                        // Replace Grid
                        self.Container.empty().html($dom.filter('#template-product-grid').html());

                        // Replace Breadcrumbs
                        $('#breadcrumb').empty().html($dom.filter('#breadcrumb').html());

                        // Replace Heading
                        self.Container.parent().children('h1').empty().html($dom.filter('h1').html());
                    }
                }

                // Setup the grid
                self.InitGrid();

                self._isLoading = false;

                if (responseData.DataLayer) {
                    HSN.DataLayer.sendData(responseData.DataLayer);
                }

                HSN.DataLayer.helpers.virtualPageview(null, 'Modal: Product List', 'Product List');

                HSN.Instance().Events.Trigger(HSN.Template.ProductGrid.EVENT.RELOADED);
            }
        });
    },

    UpdatePagingControlVisibility: function () {
        var pagingModule = $(".filtering-paging");

        var spotlightVisible = $(".top-line-filters:visible").length > 0;
        var pagingControlsVisible = $(".paging:visible").length > 0;
        
        if (spotlightVisible || pagingControlsVisible) {
            pagingModule.show();
        }        
    },

    /**
    * HSN.Template.ProductGrid#GetData() -> object
    *
    * Returns an object used for History
    **/
    GetData: function () {
        var self = this;
        var queryParams = HSN.Topology.getQueryParams(window.location);

        // remove search related params
        delete queryParams.facet;
        delete queryParams.store;

        var skip = $('#skip').val();
        var take = $('#take').val();
        var page = $('#page').val();
        
        var sort = $('.lnav-controls .sort').length ? $('.lnav-controls .sort').val() : $('div.sort-by select.sort').val();

        if (self._isLessman) {
            sort = $('div.sort').data('id');
        }

        var topology = HSN.Topology.FromLocation(window.location);
        topology.facets = this.GetSelectedFacetIds();

        var data = Object.assign(queryParams, {
            topology: topology, sort: sort, skip: skip, take: take, page: page, scroll: this._isScrollAll
        });

        if(this._searchQuery){
            data.query = this._searchQuery;
        }

        return data;
    },
        
    /**
    * HSN.Template.ProductGrid#DoScrollAll() -> void
    *
    * Sets scroll all mode.
    **/
    DoScrollAll: function () {
        if (this._isScrollAll) {
            this.OnUIUpdate(this._UiState.SCROLL);
            return;
        }

        this._isScrollAll = true;

        $("#skip").val("");
        $("#take").val("");
        $("#page").val(1);

        var data = this.GetData();
        delete data.skip;
        delete data.take;
        delete data.page;
        data.scroll = "all";
        this.AddHistoryItem(data);
    },

    /**
    * HSN.Template.ProductGrid#DoPaging() -> void
    *
    * Sets paging mode.
    **/
    DoPaging: function () {
        this._isScrollAll = false;
        this.OnUIUpdate(this._UiState.PAGED);

        this._isScrollAll = false;

        $("#skip").val("");
        $("#take").val("");
        $("#page").val(1);

        var data = this.GetData();
        delete data.scroll;
        delete data.skip;
        delete data.take;
        this.AddHistoryItem(data);
    },

    /**
    * HSN.Template.ProductGrid#LoadProducts() -> void
    *
    * Loads the next products for scroll all mode.
    **/
    LoadProducts: function () {
        var self = this;

        if (this._isLoading || this._areNoMoreResults) {
            return;
        }

        var $loadingContainer = $('#loading-container');
        var nextTake = $('#next-take');
        var nextPage = $('#next-page');
        var nextSkip = $('#next-skip');
        var take = parseInt(nextTake.val());
        var page = parseInt(nextPage.val());
        var skip = parseInt(nextSkip.val());

        this._isLoading = true;
        $loadingContainer.show();

        var sort = $('div.sort-by select.sort').val();
        var data = this.GetData();
        data.page = page;
        data.skip = skip;
        data.take = take;

        var request = $.ajax(this.GetAjaxUrl(data), {
            dataType: 'json'
        });

        var self = this;
        request.done(function(responseData){
            var $dom = $($.parseHTML(responseData.View, document));
            var items = $dom.find('.item');
                    
            // Add Products to Grid
            if (self.Container.is('.lessman')) {
                self.Container.find('.item:last').after(items);
            }
            else {
                self.Container.find('.grid-right .item:last').after(items);
            }

            // Set paging info
            var nextTakeVal = parseInt($dom.find('#next-take').val());
            self._areNoMoreResults = nextTakeVal === 0;

            nextTake.val(nextTakeVal);
            nextPage.val($dom.find('#next-page').val());
            nextSkip.val($dom.find('#next-skip').val());
                
            $loadingContainer.hide();
                    
            // Setup the grid
            self.InitGrid();

            self._isLoading = false;
            self.ScrollToTopCallout.UpdatePosition();

            HSN.Instance().Events.Trigger(HSN.Template.ProductGrid.EVENT.LOADEDMORE);
        });
    },

    /**
        * initalize grid, filters, and pagination
        */
    InitGrid: function () {
        var self = this;

        this.Hydrate();
        this.RefreshFilterDisplay();

        this.Application.FlyoutManager.Add(new HSN.Flyout({
            trigger: this.Container.find('.sort label'),
            flyout: this.Container.find('.sort ul'),
            triggerEvent: HSN.Flyout.TRIGGER_EVENT.CLICK
        }));

        $('img.lazy', self.Container).lazyloadDisable({ event: 'scroll', namespace: 'gridLazyLoad' });
        $('img.lazy', self.Container).lazyload({
            skip_invisible: false, event: 'scroll', namespace: 'gridLazyLoad'
        });

        self.Container.find(".video").each(function () {
            new HSN.Template.ProductVideo({
                application: HSN.Instance(),
                container: $(this),
                triggerElement: ".video",
                videoUrls: {
                    httpUrl: $(this).data("httpUrl")
                },
                videoAnalytics: {
                    name: $(this).data("analyticName"), category: $(this).data("analyticCat")
                },
                assetId: $(this).data("assetid"),
                webpid: $(this).data("webpid"),
                backgroundColor: "#000000"
            });
        });

        //HSN.Instance()._getFavoriteService().CheckForFavorites(".favorite-link:not(.favorite-queried)");

        //  HSN.DataLayer.sendData({ 'grid_filters': null });
        //  HSN.DataLayer.helpers.virtualPageview(data.SerializedDataLayerUdo, "grid filters", "grid filters");

        self.OnUIUpdate(self._isScrollAll ? self._UiState.SCROLL : self._UiState.PAGED);
        self.adjustProductGrid();

        HSN.ResponsiveCells.prototype.StaticReRunDefault();

        self.SwatchBox.init({ selector: '.swatchbox', replaceImage: true, replaceText: true });
    },

    CheckPrivateSale: function () {
        var self = this;
        var promoId = $("#privateSale", self.Container).data("promoId");

        if(promoId > 0) {           
            $.ajax("/stores-actions/private-sale/validate-customer", {
                dataType: "json",
                method: "POST",
                data: {promotionId: promoId},
                success: function(responseData) {
                    if(typeof (responseData) !== "undefined" && responseData.showEmailCapture) {
                        HSN.Instance().GetPrivateSaleEmailCaptureModal().Show(promoId);
                    }
                }
            });          
        }
    },

    /**
        * Adds a filter and updates
        */
    AddFilter: function(filterId, andUpdate) {
        andUpdate = andUpdate !== false;
        this.FilterCheckboxes[filterId].forEach(function(fcb) { fcb.check(true); });
        if(andUpdate){
            this.OnFilterChange();
        }
    },

    /**
        * Removes a filter and updates
        */
    RemoveFilter: function(filterId, andUpdate) {
        andUpdate = andUpdate !== false;
        this.FilterCheckboxes[filterId].forEach(function(fcb) { fcb.check(false); });
        if(andUpdate){
            this.OnFilterChange();
        }
    },

    /**
        * Sets Department Id and updates
        */
    SetDepartmentId: function(deptId) {
        let data = this.GetData();
        data.topology.deptId = deptId;
            
        this.RefreshFilterDisplay();
        this.AddHistoryItem(data);
    },

    /**
    * HSN.Template.ProductGrid#ClearAllFilters() -> void
    *
    * Clears all selected filters.
    **/
    ClearAllFilters: function () {
        var self = this;
            
        var selected = this.GetSelectedFilters();
        $.each(selected, function(_,f) {
            self.RemoveFilter(f.id, false);
        });

        this.OnFilterChange();
    },

    GetSelectedFilters: function() {
        var selectedCheckboxArrs = Object.filter(this.FilterCheckboxes, function(fcbArr, id) {
            return fcbArr[0].isChecked();
        });

        return $.map(selectedCheckboxArrs, function(fcbArr) {
            var $cb = $(fcbArr[0].checkbox);

            return {
                name: $cb.data("name"), 
                id: $cb.data("id"), 
                isAttribute: $cb.data("isAttribute"), 
                groupName: $cb.data("group-name")
            };
        });
    },

    GetSelectedFacetIds: function() {
        return this.GetSelectedFilters().map(function(f) { return f.id.toString() });
    },

    /**
        * Gets a Url that represents the current topology, sort, etc.
        * @param {object} data - additional data to pass in url.
        */
    GetUrl: function(data) {
        var url = "";

        if(this._noTopology){
            url = this._baseUrl;
        } else {
            url = data.topology.toUrl(this._baseUrl, this._withSlug, this._searchQuery != undefined);
        }

        var joiner = url.indexOf("?") === -1 ? "?" : "&";

        var queryData = Object.assign({}, data);
        delete queryData.topology;

        if(queryData.scroll) {
            queryData.scroll = "all";
        } else {
            delete queryData.scroll;
        }
        queryData.view = "all";

        return url + joiner + $.param(queryData, true);
    },

    /**
    * Gets a Url that represents the current topology, sort, etc.
    * @param {object} data - additional data to pass in url.
    */
    GetAjaxUrl: function(data) {
        var url = "";
        if(this._noTopology){
            url = this._ajaxUrl;
        } else {
            url = data.topology.toUrl(this._ajaxUrl, false);
        }
        var joiner = url.indexOf("?") === -1 ? "?" : "&";

        var queryData = Object.assign({}, data);
        delete queryData.topology;

        if(queryData.scroll) {
            queryData.scroll = "all";
        } else {
            delete queryData.scroll;
        }
        queryData.view = "all";

        return url + joiner + $.param(queryData, true);
    },

    /**
    * HSN.Template.ProductGrid#RefreshFilterDisplay() -> void
    *
    * Builds display for My Filters and breadcrumbs.
    **/
    RefreshFilterDisplay: function () {
        var filtersArr = this.GetSelectedFilters();

        // Sort by name, groupName, then move Brands to top.
        filtersArr
            .sort(function(a,b) {
                return (a.name > b.name) - (a.name < b.name);
            })
            .sort(function(a,b) {
                return (a.groupName > b.groupName) - (a.groupName < b.groupName);
            })
            .sort(function(a,b) {
                var x = a.groupName === "Brand";
                var y = b.groupName === "Brand";

                if(x && y) return 0;
                if(x) return -1;
                if(y) return 1;
                return 0;
            });

        var buildBreadcrumbHtml = function(filters){
            var filterCount = filters.length;
            var html = '<ul class="filtered-by">';

            if(filterCount > 0){
                html += '<li class="different filtered-by">FILTERED BY:</li>';
            }

            html += filters.map(function(filter) {
                var id = filter.id;
                var name = filter.name.trim();
                var groupName = (filter.groupName || "").trim();

                return '<li data-id="' + id + '" data-name="' + name + '" title="Remove ' + name + '" data-group-name="' + groupName + '" class="filtered-by breadcrumb-attribute" id="breadcrumb-' + id + '" ><span>' + name + '</span></li>';
            }).join('');

            html += '</ul>';

            return html;
        };
    
        var buildFilteredByHtml = function(filters) {
            var html = "";

            html += filters.map(function(filter) {
                var id = filter.id;
                var name = filter.name.trim();
                var groupName = (filter.groupName || "").trim();

                var icon = filter.isAttribute ? "<span class='attribute-filter-icon attribute-" + id + "'></span>" : "";

                return "<li data-id=\"" + id + "\" data-name=\"" + name + "\" title=\"Remove " + name + "\" data-group-name=\"" + groupName + "\" class=\"lnav-selected-filter\" id=\"breadcrumb-" + id + "\" tabindex=\"0\">" + icon + "<span aria-hidden=\"true\">" + name + "</span></li>";
            }).join('');

            return html;
        };

        $(".lnav-selected-filters").toggle(filtersArr.length > 0);
        $(".lnav-selected-filters dd ul").html(buildFilteredByHtml(filtersArr));
            
        $("#breadcrumb ul.filtered-by").remove();
        $("#breadcrumb ol, #breadcrumb .searched-for").last().after(buildBreadcrumbHtml(filtersArr));
            
        // for IE8
        // TODO: still needed?
        $(".last-child").removeClass("last-child");
        $("#breadcrumb li").last().addClass("last-child");
    },

    SendEdgecaseFilterEvent: function (me) {
        if (me != null && typeof $EC != "undefined") {
            var filterAction = $(me).is(":checked") ? "select" : "unselect";
            var filterValue = $(me).data("name");
            var filterName = $(me).data("group-name");
            $EC.track('filterAction:' + filterAction, {
                filterName: filterName,
                filterValue: filterValue
            });
        }
    },

    /**
    * Hydrates event handlers and info after DOM updates.
    **/
    Hydrate: function() {
        this.hydrateCount = (this.hydrateCount || 0) + 1;

        this.HydrateFilters();
        this.HydrateBreadcrumbs();
    },

    HydrateFilters: function() {
        var self = this;
        this.FilterCheckboxes = {};
            
        $('input[id^="spotlight-filter-"]:checkbox, input[id^="filter-"]:checkbox')
            .each(function(_, cb){
                var id = $(cb).data("id");
                // Checkbox can appear in more than one group
                var fcbArr = self.FilterCheckboxes[id] || [];
                fcbArr.push(new FancyCheckbox(cb));
                self.FilterCheckboxes[id] = fcbArr;
            });
    },
    
    /**
    * HSN.Template.ProductGrid#HydrateBreadcrumbs -> void
    *
    * Hydrates breadcrumb event handlers after DOM updates.
    **/
    HydrateBreadcrumbs: function() {
        var self = this;

        self.Breadcrumbs = $("#breadcrumb");
        self.Breadcrumbs
            .on("click", "li.breadcrumb-attribute", function (e) {
                var name = $(this).data("name");
                var id = $(this).data("id");

                doCMRemoveBreadcrumb(name);
                self.RemoveFilter(id);
                self.SendEdgecaseFilterEvent(this);
            });
    },
};

HSN.Template.ProductGrid.EVENT = {
    LOADED: 'HSN.Template.ProductGrid:LOADED',
    RELOADED: 'HSN.Template.ProductGrid:RELOADED',
    LOADEDMORE: 'HSN.Template.ProductGrid:LOADEDMORE'
};


// Helper Components
// TODO: Move out into modules after webpack/babel transition is done?

    
/**
    * class FancyCheckbox
    * 
    * Makes checkboxes look better and changes :checked prop
    */
var FancyCheckbox = function(checkbox) {
    //var self = this;
    var $cb = $(checkbox);

    this.checkbox = $cb;
    this.span = $cb.closest("span.checkbox");

    $cb.addClass("fancy");

    //$cb.closest("li").find("label")
    //    .mousedown(function (e) {
    //        self.click(true);
    //    }).on("mouseup, mouseleave", function (e) {
    //        self.click(false);
    //    }).hover(function (e) {
    //        self.hover(true);
    //    }, function (e) {
    //        self.hover(false);
    //    });

    if(this.isChecked()){
        this.check(true);
    }
};

FancyCheckbox.prototype = {
    isChecked: function() {
        return this.checkbox.is(":checked");
    },
    check: function(bool) {
        // set checked prop without firing click event.
        this.checkbox.prop("checked", bool);
        this.span.toggleClass("checked", bool);

        this.click(false);
    },
    hover: function(bool) {
        this.span.toggleClass("hovered", bool);
    },
    click: function(bool) {
        this.span.toggleClass("clicked", bool);
    },
};

    
var ScrollToTopCallout = function(container, elementSelector) {
    var self = this;
    var $container = $(container);
    var $window = $(window);
        
    var minUpdateTime = 20;
    var updateTimer, lastUpdateTime = 0;

    this.UpdatePosition = function () {
        /*var grid = $container;
        var scrollToTop = $(elementSelector);

        var gridHeight = grid.height();
        if (gridHeight == 0)
            gridHeight = grid.prop("scrollHeight");

        var gridOffset = grid.offset();

        if ($window.scrollTop() > 100) {
            var offset = {
                left: gridOffset.left + grid.outerWidth() - 64, top: $window.scrollTop() + $window.height() - 87
            };
                
            if (gridOffset.top + gridHeight < $window.scrollTop() + $window.height()) {
                offset.top = gridOffset.top + gridHeight - 55;
            }
            scrollToTop.offset(offset);
            scrollToTop.fadeIn({
                complete: function () {
                    // So the button is shown on initial load
                    scrollToTop.offset(offset);
                }
            });
        }
        else {
            var offset = {
                left: gridOffset.left + grid.outerWidth() - 64, top: $window.scrollTop() + $window.height() - 87
            };
            scrollToTop.offset(offset);
            scrollToTop.fadeOut();
        }
        if (gridOffset.top + gridHeight < $window.scrollTop() + $window.height()) {
            scrollToTop.offset({ top: gridOffset.top + gridHeight - 55});
        }*/
        var el = $(elementSelector);
        if ($window.scrollTop() > 100)
            el.fadeIn();
        else
            el.fadeOut();
        
    };

    $('body').on("click", elementSelector, function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
};

// helper functions
Object.filter = function(obj, predicate) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }
    return result;
};

Object.map = function(obj, f) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = f(obj[key]);
        }
    }
    return result;
}

// Polyfill
if (typeof String.prototype.trim !== "function") {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    };
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}


// WEBPACK FOOTER //
// ./assets/js/HSN/Template/ProductGrid.js